import { useSelector } from 'react-redux';

import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import {
	selectOneBankIDFlowEnabled,
	selectOneButtonFlow,
	selectEnableInhouseJackpot
} from '~/components/brand/ducks/selectors';
import { currentGameSelector } from '~/components/casino-shared/game-loader/ducks/selectors.js';
import { UnauthenticatedHeader } from '~/components/header/unauthenticated-header';
import LoginLink from '~/components/header/login-link';
import UserDetails from '~/components/header/user-details.js';
import { Bigger, isSmallerSelector } from '~/components/layout/mediaquery';
import InhouseJackpotButton from '~/components/casino-shared/inhouse-jackpot/inhouse-jackpot-button.js';
import { TournamentRankButton } from '~/components/casino-shared/tournaments/async';
import useIsTournamentRankAvailable from '~/components/casino-shared/tournaments/utils/use-is-tournament-rank-available';
import PageHeadRightSide from './pagehead-right-side.js';
import ButtonRegister from './button-register.js';

const RightContainerHeader = ({ isInGame }) => {
	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlow);
	const isSmaller = useSelector(isSmallerSelector);
	const authenticated = useSelector(authenticationSelector);
	const showLoginLink = (!oneBankIDFlowEnabled && !oneButtonFlow) || isSmaller;
	const isInhouseJackpotEnabled = useSelector(selectEnableInhouseJackpot);
	const currentGame = useSelector(currentGameSelector);

	const isInhouseJackpotVisible = isInhouseJackpotEnabled && !!currentGame?.inhouseJackpots?.length && isInGame;
	const isTournamentRankAvailable = useIsTournamentRankAvailable(currentGame?.code) && !!isInGame;

	return (
		<PageHeadRightSide isInGame={isInGame}>
			{authenticated ? (
				<>
					{isInhouseJackpotVisible && <InhouseJackpotButton isDesktop />}
					{isTournamentRankAvailable && !!currentGame?.code ? (
						<TournamentRankButton gameCode={currentGame.code} />
					) : null}
					<UserDetails isInGame={isInGame} />
				</>
			) : (
				<>
					<Bigger>
						<UnauthenticatedHeader ButtonRegister={ButtonRegister} />
					</Bigger>
					{showLoginLink && <LoginLink />}
				</>
			)}
		</PageHeadRightSide>
	);
};

export default RightContainerHeader;
